var _rect, _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#286385",
    stroke: "#286385"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 25C24.7625 25 27 22.7625 27 20C27 17.2375 24.7625 15 22 15C19.2375 15 17 17.2375 17 20C17 22.7625 19.2375 25 22 25ZM22 27.5C18.6625 27.5 12 29.175 12 32.5V33.75C12 34.4375 12.5625 35 13.25 35H30.75C31.4375 35 32 34.4375 32 33.75V32.5C32 29.175 25.3375 27.5 22 27.5Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 25.4495L32.3224 24.6737L30.3187 22.6699L29.5625 25.4495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0585 14.8249C38.8826 14.6494 38.6442 14.5508 38.3956 14.5508C38.1471 14.5508 37.9087 14.6494 37.7327 14.8249L37.2988 15.2588L39.716 17.7023L40.1631 17.2554C40.3386 17.0795 40.4372 16.8411 40.4372 16.5925C40.4372 16.344 40.3386 16.1056 40.1631 15.9296L39.0585 14.8249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5449 22.0129L32.9753 24.4432L39.2743 18.1442L36.8571 15.7007L30.5449 22.0129Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthor);
export default __webpack_public_path__ + "static/media/author.09af842cb7a83b7feb5111e5315aad13.svg";
export { ForwardRef as ReactComponent };